import { ComponentType } from 'react'

import { Button, IconProps } from '@chakra-ui/react'

type CircularButtonProps = {
  icon?: ComponentType<IconProps>
  size?: 'sm' | 'md' | 'lg'
  onClick?: () => void
  colorPalette?: string
}

/* eslint-disable react/prop-types */
const CircularButton: React.FC<CircularButtonProps> = ({
  icon: Icon,
  size = 'sm',
  onClick,
  colorPalette = 'gray',
  ...props
}) => {
  const sizes = {
    sm: '24px',
    md: '50px',
    lg: '60px',
  }
  const iconSizes = {
    sm: '16px',
    md: '24px',
    lg: '30px',
  }

  return (
    <Button
      alignItems="center"
      justifyContent="center"
      display="flex"
      width={sizes[size]}
      minWidth={sizes[size]}
      height={sizes[size]}
      minHeight={sizes[size]}
      padding={0}
      borderRadius="full"
      colorPalette={colorPalette}
      onClick={onClick}
      {...props}
    >
      {Icon && <Icon boxSize={iconSizes[size]} />}
    </Button>
  )
}
/* eslint-enable react/prop-types */

export default CircularButton
